export default {
  backendValidationErrorMessage: 'Oops, an error has occurred. See below.',
  backendValidationUnexpectedErrorMessage: 'Oops, an error has occurred.',
  saveButtonText: 'Save',
  cancelButtonText: 'Cancel',
};
